module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/error404_657d599.jpg";